import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-mist contour-light py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-94" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-95" data-mp="9srv5cobru2o">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border-2 border-yellow bg-white p-8 shadow-card sm:p-12" data-id="element-96" data-mp="etz2xbqgwt9c">
          <span className="inline-flex rounded-full bg-green p-4 text-white" data-id="element-97" data-mp="sm5hwuhvwu77">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-98" data-mp="xk73bm2s95lu" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-ink" data-id="element-99" data-mp="12jjzixfjnp13">Garantía total de 7 días</h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-100" data-mp="17hbnjgd2ir00">
            Abrí los 9 tomos. Revisá los 5 bonos. Usalos en tu clase más difícil esta semana. Si sentís que tus alumnos no
            respondieron mejor, o que el material no te ahorró horas de trabajo:
          </p>
          <p className="mt-6 rounded-lg bg-greenSoft px-5 py-4 text-lg font-extrabold text-green" data-id="element-101" data-mp="1vthgefv1pcnd">
            Te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-102" data-mp="2oiewccbsaxcy">
            Porque si el material no te da el valor que prometemos, no queremos quedarnos con tu dinero.
          </p>
        </motion.div>
      </div>
    </section>;
}